module.exports = __webpack_public_path__ + "static/img/guoyao_sp.40f2b409.png";